import TurndownService from 'turndown';
import { marked } from 'marked';

const turndownService = new TurndownService({
  headingStyle: 'atx',
  bulletListMarker: '-',
  codeBlockStyle: 'fenced',
  emDelimiter: '*',
});

turndownService.addRule('preserveLineBreaks', {
  filter: ['br'],
  replacement: () => '\n',
});

// Configure marked once for consistent HTML output
marked.setOptions({
  breaks: true,
  gfm: true,
});

const htmlTagPattern = /<([a-z][\w\-]*)(\s[^>]*)?>/i;

const normalizeEscapes = (content: string): string =>
  content.replace(/(^|\n)\\(#)/g, '$1$2');

export const htmlToMarkdown = (html?: string | null): string => {
  if (!html) {
    return '';
  }
  const markdown = turndownService.turndown(html);
  return normalizeEscapes(markdown);
};

export const markdownToHtml = (markdown?: string | null): string => {
  if (!markdown) {
    return '';
  }
  return marked.parse(markdown);
};

export const normalizeToMarkdown = (content?: string | null): string => {
  if (!content) {
    return '';
  }
  const trimmed = content.trim();
  if (!trimmed) {
    return '';
  }
  const normalized = htmlTagPattern.test(trimmed)
    ? htmlToMarkdown(trimmed)
    : trimmed;
  return normalizeEscapes(normalized);
};
